export type progressType = {
  label: string;
  value: string | null;
};

export const ButtonGroupDummyData = {
  shareholders: [
    { key: '2020', placeholder: '2020' },
    { key: '2019', placeholder: '2019' },
    { key: '2018', placeholder: '2018' },
    { key: '2017', placeholder: '2017' },
    { key: '2016', placeholder: '2016' },
  ],
  button1: [
    { key: '1D', placeholder: '1D' },
    { key: '1W', placeholder: '1W' },
    { key: '1M', placeholder: '1M' },
    { key: '1Y', placeholder: '1Y' },
    { key: '3Y', placeholder: '3Y' },
    { key: '5Y', placeholder: '5Y' },
  ],
  button2: [
    { key: 'NSE', placeholder: 'NSE' },
    { key: 'BSE', placeholder: 'BSE' },
  ],
  carat: [
    { key: '9k', placeholder: '9k' },
    { key: '12k', placeholder: '12k' },
    { key: '14k', placeholder: '14k' },
    { key: '18k', placeholder: '18k' },
    { key: '22k', placeholder: '22k' },
    { key: '24k', placeholder: '24k' },
  ],
  gram: [
    { key: '1gm', placeholder: '1 g' },
    { key: '1kg', placeholder: '1 kg' },
  ],
  intervals1: [
    { key: '1W', placeholder: '1W' },
    { key: '1M', placeholder: '1M' },
    { key: '3M', placeholder: '3M' },
    { key: '6M', placeholder: '6M' },
  ],
  intervals2: [
    { key: '1W', placeholder: '1W' },
    { key: '1M', placeholder: '1M' },
  ],
  button3: [
    { key: 'all', placeholder: 'All Stocks' },
    { key: 'topGain', placeholder: 'Top Gainers' },
    { key: 'topLose', placeholder: 'Top Losers' },
  ],
  tabGroup: [
    { key: 'Overview', placeholder: 'Overview', id: 'graph-section' },
    { key: 'Financials', placeholder: 'Financials', id: 'financials' },
    { key: 'Peers', placeholder: 'Peers', id: 'cards-section' },
    { key: 'Dividends', placeholder: 'Dividends', id: 'divident-section' },
    { key: 'Bonuses', placeholder: 'Bonuses', id: 'divident-section' },
    { key: 'Announcements', placeholder: 'Announcements', id: 'cards-section' },
    { key: 'About', placeholder: 'About', id: 'about-section' },
  ],
  tabGroupListing: [
    { key: 'all', placeholder: 'All stocks', id: 'all-stocks-mob' },
    { key: 'topGain', placeholder: 'Top gainers', id: 'top-gainers-mob' },
    { key: 'topLose', placeholder: 'Top losers', id: 'top-losers-mob' },
  ],
};
export type DIVIDENT_TABLE_DATA_TYPE = {
  stock: number;
  div_date: string;
  div_type: string;
  dividend_amount: number;
  dividend_percentage: number;
  record_date: string;
};

export type BONUS_TABLE_DATA_TYPE = {
  stock: number;
  bonus_date: string;
  bonus_ratio: string;
  remark: string;
  record_date: string;
};

export type DUMMY_LISTING_TABLE_DATA_TYPE = {
  company_name: string;
  company_slug: string;
  company_sector: string;
  price: number | null;
  prev_close: number | null;
  mcap: number | null;
  pe_ratio: number | null;
  change: number | null;
  pricediff: number | null;
  returns_5y: string | null;
};
export const DUMMY_LISTING_TABLE_DATA = {
  headers: [
    { key: 'company_name', placeHolder: 'COMPANY', slug: 'companyname' },
    { key: 'price', placeHolder: 'PRICE', slug: 'stock_price_infos__price' },
    {
      key: 'prev_close',
      placeHolder: 'PREVIOUS CLOSE',
      slug: 'stock_price_infos__oldprice',
    },
    {
      key: 'mcap',
      placeHolder: 'MCAP (IN CR)',
      slug: 'stock_price_infos__mcap',
    },
    {
      key: 'pe_ratio',
      placeHolder: 'P/E',
      slug: 'stock_price_infos__pe_ratio',
    },
  ],
  data: [
    {
      company_name: 'Adani Transmission Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Chemicals',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Fairchem Organics Ltd',
      company_slug: 'Fairchem_Organics_Ltd',
      company_sector: 'Energy',
      price: '₹114.08',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Vineet Laboratories Ltd',
      company_slug: 'Vineet_Laboratories_Ltd',
      company_sector: 'Biotechnology',
      price: '₹54.09',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Meghmani Finechem Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Chemicals',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Chemplast Sanmar Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Chemicals',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'DC Infotech And Comm...',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Automobiles',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Euro Multivision Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Telecommunications',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Adani Transmission Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Chemicals',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Adani Transmission Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Chemicals',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Adani Transmission Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Chemicals',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Adani Transmission Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Chemicals',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Adani Transmission Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Chemicals',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'DC Infotech And Comm...',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Automobiles',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Euro Multivision Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Telecommunications',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'DC Infotech And Comm...',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Automobiles',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
    {
      company_name: 'Euro Multivision Ltd',
      company_slug: 'Adani_Transmission_ltd',
      company_sector: 'Telecommunications',
      price: '₹154.98',
      prev_close: '₹142.98',
      mcap: '₹123342',
      pe_ratio: '0.10',
      returns_5y: '12.87',
    },
  ],
};

export type TICKER_BAR = {
  co_code: number;
  nsesymbol: string;
  url_slug: string;
  stock_price_infos: {
    price: number;
    pricediff: number;
    change: number;
    prev_close: number;
    today_low: number;
    today_high: number;
    price_updated_time: number;
  };
};
